export const API_ENDPOINTS = {
    
  /* -------------------------------------------------- erpservice -----------------------------------------------------------------*/

  // Account Module
  VALIDATE_USER: 'erpservice/Account/validateuser?userName=',
  VALIDATE_USER_OTP: 'erpservice/account/validateuserotp',
  RESET_PASSWORD: 'erpservice/account/resetpassword',
  USER_LOGIN: 'getUser/Userlogin',
  CHANGE_PASSWORD:'erpservice/Account/ChangePassword',
  USERS_SEARCH:'erpservice/account/users?search=',
  CREATE:'erpservice/account/create',
  USER_EXISTS:'erpservice/account/userExists?email=',
  UPDATE:'erpservice/account/update',
  COPS_USERS:'erpservice/account/copsusers',
  USER_DETAIL:'erpservice/account/userdetail?userId=',
  DELETE:'erpservice/account/delete/',
  USER : 'erpservice/account/user/',
  DELETE_BY_ID:'erpservice/account/delete?Id=',
  USER_BY_ID:'erpservice/Account/userbyid',

  //Rights
  GET_RIGHTS_TREE: 'erpservice/rights/getrightstree',
  MENU_TREE:'erpservice/rights/menutree',
  
  //Common Module
  TABLE_NAME: 'erpservice/common/history?tableName=',
  GET_FILE:'erpservice/common/getfile?filePath=',
  AUTO_SEARCH:'erpservice/common/autosearch?keyName=',
  TBL_CONFIG:'reportservice/common/tblconfig?type=',
  REPORT_CONFIG:'reportservice/common/reportconfig?type=',
  FILTER:'erpservice/common/filter',
  UPLOAD:'erpservice/common/upload',
  UPLOAD_BASE64:'erpservice/common/uploadbase64',
  GET_COLUMN_PREFERENCE: 'erpservice/common/getcolumnprefrence?Pageid=',
  GET_BULK_DIALOG_CONFIG_BY_PAGE_ID:'erpservice/common/getdialogconfigforbulkuploadandbulksavebypageid?PageId=',
  USER_COLUMN_PREFERENCE:'erpservice/common/usercolumnprefrence',
  STORE_EXECUTION_RIGHTS_LIST:'erpservice/common/storeexecutionrightslist',
  STATE_AND_CATEGORY_BY_STORE_CODE:'erpservice/common/stateandcategorybystorecode',
  GET_ALL_SELECTION_ITEMS:'erpservice/common/getallselectionitems',
  MULTITABLE:'erpservice/common/multitable?type=',
  GET_PDF_PATH:'erpservice/common/getPdfPath',
  DELETE_DOCUMENT_BY_ID:'erpservice/common/deletedocumentbyid',
  EXPORT_DASHBOARD_DATA:'erpservice/common/exportdashboarddata',

  //Emailschedule Module
  GET_REPORT_MAIL: 'erpservice/emailschedule/getreportmail?pageid=',
  SAVE_UPDATE : 'erpservice/emailschedule/saveupdate',
  GET_SEARCH_FIELD_DETAILS:'erpservice/emailschedule/GetSearchFieldDetails?Pageid=',

  //Cashbook
  GET_CASH_BOOK_DETAIL:'erpservice/cashbook/getcashbookdetail?Id=',
  APPROVE_REJECT_CASH_BOOK:'erpservice/cashbook/approverejectcashbook',
  APPROVE_REJECT_CASH_BOOK_REASON:'erpservice/cashbook/approverejectcashbookreason?cposHeaderId=',
  SEARCH_CASHBOOK_CATEGORY:'erpservice/cashbook/searchcashbookcategory',
  SAVE_CASHBOOK_CATEGORY:'erpservice/cashbook/savecashbookcategory',
  SAVE_CASHBOOK_ALLOCATION:'erpservice/cashbook/savecashbookallocation',
  GET_PETTY_CASH:'erpservice/cashbook/getPettyCashMaster',
  GET_CASHBOOK_CATEGORY:'erpservice/cashbook/getcashbookcategory',

  //Sales
  DEFAULT_DASHBOARD_GRAPH_DATA:'erpservice/sales/defaultdashboardgraphdata',
  CPOS_INVOICE_HEADER_LIST:'erpservice/sales/cposinvoiceheaderlist',
  CPOS_SAP_INVOICE_HEADER_LIST:'erpservice/sales/cpossapinvoiceheaderlist',
  CPOS_SALES_MIS_REPORT:'erpservice/sales/cpossalesmisreport',

  //Store
  ADVANCE_SEARCH_STORE:'erpservice/store/advancesearchstore',
  DEFAULT_STORE_DATA:'erpservice/store/defaultstoredata?userid=',
  GET_STORE_TYPES:"erpservice/store/getstoretypes",
  GET_STORES_BY_STORE_TYPE:"erpservice/store/getstoresbystoretype",
  LIVE_STORE_LIST:'erpservice/store/livestorelist',
  APPROVE_DOC:'erpservice/store/approvedoc',
  GET_STORE_INFO_LIST:'erpservice/store/getstoreinfolist',
  STOCK_ADJUSTMENT_BULK_SAVE:'erpservice/store/stockadjustmentbulksave',
  SAVE_STORE:'erpservice/store/savestore',
  STORE_MASTER_LIST:'erpservice/store/storemasterlist',

  //Payment
  PAYMENT:'payment/filter',
  CPOS_PAYMENT_OUTSTANDING_DETAIL:'erpservice/payment/cpospaymentoutstandingdetail',

  //Store Notification
  NOTIFICATION_COUNT:'erpservice/storenotification/notificationcount',
  CHECK_STAGE:'erpservice/storenotification/checkstage',
  STORE_REMARKS_LIST:'erpservice/storenotification/storeremarkslist',
  ADD_STORE_REMARK:'erpservice/storenotification/addstoreremark',
  ADD_NOTIFICATION_REMARK:'erpservice/storenotification/addnotificationremark',
  REMARKS_LIST:'erpservice/storenotification/remarkslist',
  GET_STORE_NOTIFICATION_LIST:'erpservice/storenotification/getstorenotificationlist',

  // Notification
  GET_NOTIFICATION_TYPE_LIST:'erpservice/notification/getnotificationtypelist',
  GET_NEXT_NOTIFICATION_ID:'erpservice/notification/getNextNotificationId',
  SAVE_OR_UPDATE_NOTIFICATION_MASTER:'erpservice/notification/SaveOrUpdateNotificationMaster',
  GET_NOTIFICATION_BY_ID:'erpservice/notification/getnotificationbyid',

  //Report Request
  REPORT_REQUEST_SAVE:'erpservice/reportrequest/save',
  REPORT_REQUESTSAVE:'reportrequest/save',

  //GroupMaster
  GROUP_LIST:'erpservice/groupmaster/grouplist',
  ALL_PRODUCTS_EXCEPT_GROUP:'erpservice/groupmaster/allproductsexceptgroup',
  ALL_PRODUCTS_OF_GROUP:'erpservice/groupmaster/allproductsofgroup',
  ADD_GROUP:'erpservice/groupmaster/addgroup',
  SAVE_GROUP_PRODUCT_MAPPING:'erpservice/groupmaster/savegropuproductmapping',
  ALL_GROUP_WITH_PRODUCTS:'erpservice/groupmaster/allgroupwithproducts',
  CHANGE_GROUP_ACTIVATION:'erpservice/groupmaster/changegroupactivation',
  EXPORT_DATA:'erpservice/groupmaster/exportdata',

  //StoreTypePercentage
  STORE_TYPE_WITH_PERCENTAGE:'erpservice/storetypepercentage/storetypewithpercentage',
  INSERT_UPDATE_PERCENTAGE:'erpservice/storetypepercentage/insertupdatepercentage',
  STORE_CODE_FOR_SELECTION:'erpservice/storetypepercentage/storecodeforselection?type=',
  SAVE_CUSTOM_STORE_PERCENT:'erpservice/storetypepercentage/savecustomstorepercent',
  GET_TYPEWISE_DATA:'erpservice/storetypepercentage/gettypewisedata?type=',
  DELETE_PERCENTAGE:'erpservice/storetypepercentage/deletepercentage?headerId=',
  
  //AdjustPoints
  GENERATED_POINTS_INFO:'erpservice/adjustpoints/generatedpointsinfo?pointId=',
  GET_GROUP_POINTS:'erpservice/adjustpoints/getgrouppoints?pointsid=',
  GET_SCHEME_TRANSACTION:'erpservice/adjustpoints/getschemetransaction?pagesize=',
  GET_GROUP_SCHEME_TRANSACTION:'erpservice/adjustpoints/getgroupschemetransaction?pagesize=',
  GET_STORE_INFO:'erpservice/adjustpoints/getstoreinfo?storeId=',
  SAVE_ADJUSTED_POINTS:'erpservice/adjustpoints/saveadjustedpoints',

  //Chat
  UPDATE_AS_READ:'erpservice/chat/updateasread?userid=',
  GET_CHAT_LIST_BY_USER_ID:'erpservice/chat/getchatlistbyuserid?UserId=',
  SAVE_ANSWER:'erpservice/chat/saveanswer?id=',   
  DOWNLOAD_ATTACHMENT:'erpservice/chat/downloadattachment',
  GET_MOBILE_USER_LIST:'erpservice/chat/getmobileuserlist?id=',

  //Employee
  GET_REPORTING_TO:'erpservice/employee/getreportingto',
  SAVE_EMPLOYEE:'erpservice/employee/saveemployee',
  GET_EMPLOYEE_BY_ID:'erpservice/employee/getemployeebyid?id=',
  GET_RELATIONSHIP_MANAGER:'erpservice/employee/getrelationshipmanager',

  //Scheme
  SEARCH_PRODUCT:'erpservice/scheme/searchproduct?status=',
  SAVE:'erpservice/scheme/save',
  SCHEME_BY_ID:'erpservice/scheme/byid?id=',

  //SchemerReport
  GET_REPORT_SCHEME_TYPE_LIST:'erpservice/schemereport/getschemetypelist',
  GET_REPORT_MEDICINE_LIST:'erpservice/schemereport/getmedicinelist',
  GET_SCHEME_REPORT_LIST:'erpservice/schemereport/getschemereportlist',

  //Scheme_new
  ITEM_BY_MRP_HAVING_ITEM:'erpservice/scheme_new/itembymrphavingitem',
  GET_ITEM_BATCH:'erpservice/scheme_new/getItemBatch',
  GET_SCHEME_LIST:'erpservice/scheme_new/getschemelist',
  GET_SEARCH_STORE_TYPE_LIST:'erpservice/scheme_new/getsearchstoretypelist',
  GET_SEARCH_STORE_LIST:'erpservice/scheme_new/getsearchstorelist',
  GET_SCHEME_TYPE_LIST:'erpservice/scheme_new/getschemetypelist',
  GET_MEDICINE_LIST:'erpservice/scheme_new/getmedicinelist',
  GET_SCHEME_BY_ID:'erpservice/scheme_new/getschemebyid?id=',
  CHECK_SCHEME:'erpservice/scheme_new/checkscheme',
  SAVE_OR_UPDATE_SCHEME_HEADER:'erpservice/scheme_new/saveorupdateschemeheader',
  STORE_TYPE_LIST:'erpservice/scheme_new/storetypeList?stateNames=',
  STORE_CODE_LIST:'erpservice/scheme_new/storecodeList',
  VALIDATE_MATERIAL_EXCEL_DISCOUNT:'erpservice/scheme_new/validateDisPercentOnMaterialexcelproducts',
  VALIDATE_FREE_MATERIAL_EXCEL_PRODUCTS:'erpservice/scheme_new/validateFreeMaterialexcelproducts?isbatchWise=',
  VALIDATE_COMBO_MATERIAL_EXCEL_PRODUCTS:'erpservice/scheme_new/validateComboSchemeexcelproducts',

  //StoreExeprocess
  GET_ALL_STATES_AND_CITY:'erpservice/storeexeprocess/getallstatesandcity',
  SAVE_STORE_STATUS:'erpservice/storeexeprocess/savestorestatus',
  LOCATION_STATUS:'erpservice/storeexeprocess/locationstatus',
  CHANGE_RM:'erpservice/storeexeprocess/changerm',
  STORE_APPROVAL:'erpservice/storeexeprocess/storeeapproval',
  DL_RE_APPROVAL:'erpservice/storeexeprocess/dlreapproval',
  UPDATE_FIRM_NAME_FLAG:'erpservice/storeexeprocess/updatefirmnameflag',
  GET_STORES_OF_CITY:'erpservice/storeexeprocess/getstoresofcity',
  GET_ALL_CITY_OF_STATE:'erpservice/storeexeprocess/getallcityofstate',
  GET_STORE_EXECUTION_RIGHTS:'erpservice/storeexeprocess/getstoreexecutionrights',
  GET_INFRASTRUCTURE_DETAILS_BY_ID:'erpservice/storeexeprocess/getinfrastructuredetailsbyid',
  DISAPPROVE_DETAILS:'erpservice/storeexeprocess/disapprovedetails',
  APPROVE_STORE:'erpservice/storeexeprocess/approvestore',
  SAVE_CITY_STATE:'erpservice/storeexeprocess/savecitystate',
  GET_BRANDING_DETAILS_BY_ID:'erpservice/storeexeprocess/getbrandingdetailsbyid',
  GET_FINALISATION_DETAILS_BY_ID:'erpservice/storeexeprocess/getfinalisationdetailsbyid',
  GET_ACCOUNT_DETAILS_BY_ID:'erpservice/storeexeprocess/getaccountdetailsbyid',
  GET_DISPATCH_DETAILS_BY_ID:'erpservice/storeexeprocess/getdispatchdetailsbyid',
  GET_OPENING_DETAILS_BY_ID:'erpservice/storeexeprocess/getopeningtailsbyid',
  GET_STORE_EXECUTION_TABS:'erpservice/storeexeprocess/getstoreexecutiontabs',
  SAVE_DOCUMENTS_STATUS:'erpservice/storeexeprocess/savedocumentstatus',
  SAVE_BRANDING_DETAILS:'erpservice/storeexeprocess/savebrandingdetails',
  SAVE_FINALISATION_DETAILS:'erpservice/storeexeprocess/savefinalisationdetails',
  SAVE_ACCOUNT_DETAILS:'erpservice/storeexeprocess/saveaccountdetails',
  SAVE_DISPATCH_DETAILS:'erpservice/storeexeprocess/savedispatchdetails',
  SAVE_OPENING_DETAILS:'erpservice/storeexeprocess/saveopeningdetails',
  SAVE_FOLLOW_UP_REMARKS:'erpservice/storeexeprocess/savefollowupremarks',
  REMOVE_STOCK_PAYMENT:'erpservice/storeexeprocess/removestockpayment',
  GET_FOLLOW_UP_REMARKS_LIST:'erpservice/storeexeprocess/getfollowupremarkslist',
  GET_SEARCH_STORE_TYPE_LIST_STORE_EXPRESS:'erpservice/storeexeprocess/getsearchstoretypelist',
  GET_ALL_CITY_STORE_EXPRESS:'erpservice/storeexeprocess/getallcity',
  STORE_EXECUTION_TRACKER_LIST:'erpservice/storeexeprocess/storeexecutiontrackerlist',
 
  //Rights
  DEFAULT_RIGHTS_DATA:'erpservice/rights/defaultrightsdata',
  SAVE_USER_RIGHTS:'erpservice/rights/saveuserrights',

  //ReturnBatch
  GET_ALL_STORE:'erpservice/returnbatch/getallstore?type=',
  GET_ALL_STATE:'erpservice/returnbatch/getallstate',
  GET_ALL_CITY:'erpservice/returnbatch/getallcity',
  GET_ALL_STORE_CATEGORY:'erpservice/returnbatch/getallstorecategory',
  GET_BATCH:'erpservice/returnbatch/getbatch',
  GET_RETURN_ITEM_BATCH:'erpservice/returnbatch/getitembatch',
  CHECK_IS_RETURN_BATCH_EXIST:'erpservice/returnbatch/checkisreturnbatchexist',
  ADD_UPDATE_RETURN_BATCH:'erpservice/returnbatch/addupdatereturnbatch',
  GET_RETURN_BATCH_DETAIL:'erpservice/returnbatch/getreturnbatchdetail?id=',

  //Export
  GET_STORE_DETAILS:'erpservice/export/getstoredetails',
  POS_INVOICE_REPORT:'erpservice/export/posinvoicereport',

  //Medicine
  GET_MEDICINES:'erpservice/medicine/getmedicines',
  SAVE_MEDICINE:'erpservice/medicine/save',
  SEARCH_PRODUCT_BY_NAME:'erpservice/medicine/searchproductbyname',
  MEDICINE_BY_ID:'erpservice/medicine/byid',
  MEDICINE_DLL:'erpservice/medicine/ddl',
  SEARCH_PRODUCTS:'medicine/searchproductbyname',
  CPOS_GET_MEDICINES_STOCK_LIST:'erpservice/medicine/cposgetmedicinestocklist',
  CPOS_GET_POS_MEDICINE_STOCK:'erpservice/medicine/cposgetposmedicinestock',

  //WelcomeKit
  WELCOME_KIT_EXISTS:'welcomekit/welcomekitexists', //
  SAVE_WELCOME_KIT:'erpservice/welcomekit/save',
  WELCOME_KIT_BY_ID:'erpservice/welcomekit/byid',

  //Bill Scheme
  ADD_OR_UPDATE_BILL_SCHEME:'erpservice/billscheme/addorupdatebillscheme',
  GET_BILL_SCHEME_LIST:'erpservice/billscheme/getbillschemelist',
  GET_BILL_SCHEME_HISTORY: 'erpservice/billscheme/getbillschemehistory',
  BILL_SCHEME_BY_ID:'erpservice/billscheme/byid',

  //Coupon Code
  GET_STORE_CATEGORY: 'erpservice/couponcodemaster/getstorecatagory',
  GET_STORE_CODE:'erpservice/couponcodemaster/getstorecode',
  CHECK_DUPLICATE_PREFIX:'erpservice/couponcodemaster/checkduplicateprefix',
  GENERATE_DYNAMIC_COUPON_CODE:'erpservice/couponcodemaster/generatedynamiccouponcode',
  SAVE_COUPON:'erpservice/couponcodemaster/savecoupon',
  GET_COUPON_CODE_DETAIL:'erpservice/couponcodemaster/getcoupondetails',
  GET_COMMON_DROPDOWN:'erpservice/couponcodemaster/getcommondropdown',
  /*~~~~~~~~~ Start Gid:#84 Coupon restructure Nidhi 20-01-2026 ~~~~---*/
  GET_COUPON_PRODUCT_CATEGORY:'erpservice/couponcodemaster/getcouponmappingitemcategory',
  GET_COUPON_CATEGORY_ITEM:'erpservice/couponcodemaster/getcouponmappingItem?itemcategory=',
  GET_COUPON_PRODUCT_ITEMBATCH:'erpservice/couponcodemaster/getcouponmappingItemBatch',
   VALIDATE_COUPON_EXCEL_PRODUCTS:'erpservice/couponcodemaster/validatecouponexcelproducts?selectedProductMappingType=',
/*~~~~~~~~~End Gid:#84 ~~~~---*/
  //Document
  DOCUMENT_SAVE: 'erpservice/documentlibrary/save',
  DOCUMENTS:'erpservice/documentlibrary/documents',
  DOCUMENT_BY_ID:'erpservice/documentlibrary/byid',

  //Catagory
  GET_ALL_PRODUCT_SEX_CEPTCATID:'erpservice/catagory/getallproductsexceptcatid',
  GET_CAT_WISE_PRODUCTS:'erpservice/catagory/getcatwiseproducts',
  GET_ALL_PRODUCTS:'erpservice/catagory/getallproducts',
  MAP_PRODUCTS_TO_CATEGORY:'catagory/mapproductstocatagory', //
  SAVE_CATEGORY:'erpservice/catagory/savecatagory',
  GET_CATEGORY_LIST: 'erpservice/catagory/getcatagorylist',

  //OtherBrand
  OTHER_BRAND_EXISTS:'erpservice/otherBrandMaster/otherbrandexists',
  SAVE_OTHER_BRAND:'erpservice/otherBrandMaster/save',
  OTHRE_BRAND_BY_ID:'erpservice/OtherBrandMaster/byid',

  //Reason
  SAVE_OR_UPDATE_REASON_MASTER:'erpservice/reason/SaveOrUpdateReasonMaster',
  GET_REASON_BY_ID:'erpservice/reason/getReasonbyid',

  //Saltmaster
  SALT_EXISTS:'erpservice/saltmaster/saltexists',
  SAVE_SALT:'erpservice/saltmaster/save',
  SALT_BY_ID:'erpservice/saltmaster/byid',

  //Purchase
  APPROVE_PO:'erpservice/purchase/approvepo',
  STATUS_LIST:'erpservice/purchase/statuslist',
  STORE_PO_ORDER:'erpservice/purchase/storepoorder',
  CPOS_PO_DETAIL:'erpservice/purchase/cpospodetail',

  //PurchaseOrder
  GET_PO_DETAIL_BY_ID:'erpservice/purchaseorderapporoval/getpodetailbyid',
  GET_ALTER_PRODUCT:'erpservice/purchaseorderapporoval/getalterproduct',
  SAVE_PO_ITEM_DETAILS:'erpservice/purchaseorderapporoval/savepoitemdetails',
  GET_APPROVED_PO_DETAIL_BY_ID:'erpservice/purchaseorderapporoval/getApprovedPoDetailById',/*~~~~ Gid : #46 Nidhi 09-12-2025 add view button on purchase order report*/

  //StoreVendorMapping
  GET_VENDOR_LIST:'erpservice/storevendormapping/getvendorlist',
  SAVE_VENDOR_MAPPING:'erpservice/storevendormapping/savevendormapping',
  GET_STORE_LIST:'erpservice/storevendormapping/getstorelist',

  //TermsAndCondition
  SAVE_OR_UPDATE_TERMS_AND_CONDITIONS:'erpservice/termsandconditions/SaveOrUpdateTermsAndConditionsMaster',
  GET_TERMS_AND_CONDITIONS_BY_ID:'erpservice/termsandconditions/getTermsAndConditionsbyid',

  /* Start Nidhi Bhosale 2026-03-23 ID(zota/cpos/cpos_web_angular):2463(CPOS)  */
  //Product Category POS Expiry Validation Management
  POS_EXPIRY_VALIDATION_GET_BY_ID:'erpservice/posexpiryvalidationmaster/getbyid',
  POS_EXPIRY_VALIDATION_SAVE:'erpservice/posexpiryvalidationmaster/insertorupdate',
  /* end Nidhi Bhosale 2026-03-23 ID(zota/cpos/cpos_web_angular):2463(CPOS)  */

  //BatchWiseSalesReport
  GET_BATCH_WISE_SALES_SECONDARY_REPORT:'erpservice/batchwisesalesreport/getBatchWiseSalesSecondaryReport',
  GET_BATCH_WISE_SALES_TERTIARY_REPORT:'erpservice/batchwisesalesreport/getBatchWiseSalesTertiaryReport',
  GET_PRODUCT_CATEGORY:'erpservice/batchwisesalesreport/getProductCategory',
  GET_PRODUCT_NAME:'erpservice/batchwisesalesreport/getProductName',
  GET_PRODUCT_BATCH:'erpservice/batchwisesalesreport/getProductBatch',
  
  //ProductWiseSalesReport
  GET_STORE_DETAIL_RETAIL:'erpservice/productWiseSalesReport/GetStoreDetailRetail',
  GET_PRODUCT_WISE_STORE_CATEGORY:'erpservice/productWiseSalesReport/GetStoreCategory',
  GET_STORE_DETAIL:'erpservice/productWiseSalesReport/GetStoreDetail',
  GET_STATUS:'erpservice/productWiseSalesReport/getStatus',
  GET_STATE:'erpservice/productWiseSalesReport/getState',
  GET_PRIMARY_REPORT:'erpservice/productWiseSalesReport/GetPrimaryReport',
  GET_SECONDARY_REPORT:'erpservice/productWiseSalesReport/GetSecondaryReport',
  GET_TERTIARY_REPORT:'erpservice/productWiseSalesReport/GetTertiaryReport',
  GET_STORE_CATEGORY_RETAIL:'erpservice/productWiseSalesReport/getStoreCategoryRetail',
  GET_PRODUCTCATEGORY:'erpservice/productWiseSalesReport/GetProductCategory',
  GET_PRODUCTNAME:'erpservice/productWiseSalesReport/GetProductName',
  ERP_PRODUCT_SALES_GET_STORE_DETAIL_RETAIL:'erpservice/productWiseSalesReport/GetStoreDetailRetail',

  //GstReport
  GET_GST_REPORT_STORE_CODE:'erpservice/gstReport/getStoreCode',
  GET_SALES_INVOICE:'erpservice/gstReport/getSalesInvoice',
  GET_SALES_RETURN:'erpservice/gstReport/getSalesReturn',
  GET_PURCHASE_INVOICE:'erpservice/gstReport/getPurchaseInvoice',
  GET_PURCHASE_RETURN:'erpservice/gstReport/getPurchaseReturn',
  GET_GST_HSN:'erpservice/gstReport/getGstHSN',
  GET_GST_DOCS:'erpservice/gstReport/getGstDocs',

  //Reports
  GET_DATA_SYNC_REPORT:'erpservice/reports/getDataSyncReport',

  //storedocumentprocess
  DELETE_STORE:'erpservice/storedocumentprocess/deletestore',
  GET_SECONDARY_DETAILS_BY_ID:'erpservice/storedocumentprocess/getsecondarydetailsbyid',
  GET_DL_DETAILS_BY_ID:'erpservice/storedocumentprocess/getdldetailsbyid',
  GET_PAYMENT_DETAILS_BY_ID:'erpservice/storedocumentprocess/getpaymentdetailsbyid',
  GET_POLICY_DETAILS_BY_ID:'erpservice/storedocumentprocess/getpolicydetailsbyid',
  GET_STORE_AGREEMENT_DETAILS_BY_ID:'erpservice/storedocumentprocess/getstoreagreementdetailsbyid',
  GET_LOCATION_HISTORY:'erpservice/storedocumentprocess/getlocationhistory',
  SAVE_PAYMENT_DETAILS : 'erpservice/storedocumentprocess/savepaymentdetails',
  GET_TAB_LIST: 'erpservice/storedocumentprocess/GetTabList',

  //productmovementreport
  GET_STATE_MASTER:'erpservice/productmovementreport/GetState_Master',
  GET_STORE_CATEGORY_MASTER : 'erpservice/productmovementreport/GetStore_Ctagory_master',
  GET_PRODUCT_MOVEMENT_REPORT_STORE_DETAIL:'erpservice/productmovementreport/GetStore_Detail',
  GET_PRODUCT_DETAIL:'erpservice/productmovementreport/GetProduct_Detail',
  GET_BATCHNO_DETAILS:'erpservice/productmovementreport/GetBatchno_Details',
  FILTER_PRODUCT_MOVEMENT_REPORT:'erpservice/productmovementreport/Filter_ProductMovementReport',

  //orderandstockassessment
  GET_PRODUCT_CATEGORY_BY_FROM_TO:'erpservice/orderandstockassessment/GetProductCategoryByFromTO',
  GET_PRODUCT_NAME_BY_PRODUCT_CATEGORY:'erpservice/orderandstockassessment/getproductnamebyproductcategory',
  GET_ORDER_AND_STOCK_ASSESSMENT:'erpservice/orderandstockassessment/getorderandstockassessment',

  //cashbook
  GET_CASHBOOK_VALIDATION:'erpservice/cashbook/getcashbookvalidation',

  //returnpolicy
  GET_RETURN_STORE_LIST:'erpservice/returnpolicy/getstorelist',
  GET_STOREDETAIL:'erpservice/returnpolicy/getstoredetail',
  CHECK_IS_RETURN_POLICY_EXIST:'erpservice/returnpolicy/CheckIsReturnPolicyExist',
  ADD_UPDATE_RETURN_POLICY:'erpservice/returnpolicy/addupdatereturnpolicy',
  GET_RETURN_POLICY_DETAIL:'erpservice/returnpolicy/getreturnpolicydetail',

  //storedocumentprocess
  GET_PERSONAL_DETAILS_BY_ID:'erpservice/storedocumentprocess/getpersonaldetailsbyid',
  GET_FIRM_DETAILS_BY_ID:'erpservice/storedocumentprocess/getfirmdetailsbyid',
  GET_STORE_DETAILS_BY_ID:'erpservice/storedocumentprocess/getstoredetailsbyid',
   /* Start Nidhi Bhosale 2026-02-18 GID(zota/cpos/cpos_web_angular):90(CPOS)  */
  GET_STORE_DETAILS_BY_Mobile:'erpservice/storedocumentprocess/getstoredetailsbymobilenoandstoreid',
  GET_STORE_DETAILS_From_UserDetails:'erpservice/storedocumentprocess/getstoredetailsfromuserdetails',
  GET_UPGRADEDOWNGRADE_OPTIONS:'erpservice/storedocumentprocess/getupgradedowngradeoptions',
   /* end Nidhi Bhosale 2026-02-18 GID(zota/cpos/cpos_web_angular):90(CPOS)  */
  SAVE_POLICY_DETAILS:'erpservice/storedocumentprocess/savepolicydetails',
  SAVE_DL_APPROVAL:'erpservice/storedocumentprocess/savedlapproval',
  SAVE_DL_APPLY_DATE_APPROVAL:'erpservice/storedocumentprocess/savedlapplydateapproval',
  SAVE_AGREEMENT_APPROVAL:'erpservice/storedocumentprocess/saveaggrementapproval',
  GET_TSTORE_AB_LIST:'erpservice/storedocumentprocess/gettstoreablist',
  GET_STORE_TYPE_LIST:'erpservice/storedocumentprocess/getstoretypelist',
  SAVE_TAB_SEQ:'erpservice/storedocumentprocess/savetabseq',
  
  // Scheme Product
  GET_SCHEME_PRODUCT_MAPPING_AND_ITEM_CATEGORY:'erpservice/scheme_new/getschemeproductmappinganditemcategory',
  GET_ITEM_CODE_BY_CATEGORY:'erpservice/scheme_new/getitemcode?itemcategory=',
  GET_ITEMS_BATCH:'erpservice/scheme_new/getItemBatch',
  VALIDATE_EXCEL_PRODUCTS_BY_MAPPING_TYPE:'erpservice/scheme_new/validateexcelproducts?selectedProductMappingType=',

  /*----------------------------------------------------------Report Service---------------------------------------------------------*/
  REPORT_LIST:'reportservice/common/reportlist?type=',
  REPORT_LIST_PublishServer:'erpservice/common/reportlist?type=', /*~~~~~~~~~~~~ Tushar 2026-04-21 PMS(14566)*/
  /*~~~~~~~~~~~~~~~~~ Tushar 2026-06-03 PMS(#19096)*/
  GET_MASTER_DATA: 'reportservice/common/masterdata',
  GET_USER_REPORT_RIGHTS:'reportservice/common/GetUserWiseReportRights?userId=',
  /*~~~~~~~~~~~~~~~~~ PMS(#19096)*/
};